import { useContext } from 'react';
import { ActionPlanContext } from 'context/ActionPlanContext';
import { isNullOrUndefined } from 'utils/validation';

const useActionPlanContext = () => {
    const context = useContext(ActionPlanContext);

    if (isNullOrUndefined(context)) {
        throw new Error('ActionPlanContext was used outside of its provider');
    }

    return context;
};

export default useActionPlanContext;
